/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React, { useEffect } from 'react';
import { Link, useParams } from 'react-router-dom';
import { Button, Col, Row } from 'reactstrap';
import { Translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntity } from './treatment-drug.reducer';

export const TreatmentDrugDetail = () => {
  const dispatch = useAppDispatch();

  const { id } = useParams<'id'>();

  useEffect(() => {
    dispatch(getEntity(id));
  }, []);

  const treatmentDrugEntity = useAppSelector(state => state.treatmentDrug.entity);
  return (
    <Row>
      <Col md="8">
        <h2 data-cy="treatmentDrugDetailsHeading">
          <Translate contentKey="tinyMedicRestApp.treatmentDrug.detail.title">TreatmentDrug</Translate>
        </h2>
        <dl className="jh-entity-details">
          <dt>
            <span id="id">
              <Translate contentKey="tinyMedicRestApp.treatmentDrug.id">Id</Translate>
            </span>
          </dt>
          <dd>{treatmentDrugEntity.id}</dd>
          <dt>
            <span id="administered">
              <Translate contentKey="tinyMedicRestApp.treatmentDrug.administered">Administered</Translate>
            </span>
          </dt>
          <dd>{treatmentDrugEntity.administered ? 'true' : 'false'}</dd>
          <dt>
            <span id="administedDose">
              <Translate contentKey="tinyMedicRestApp.treatmentDrug.administedDose">Administed Dose</Translate>
            </span>
          </dt>
          <dd>{treatmentDrugEntity.administedDose}</dd>
          <dt>
            <span id="administedDoseUnit">
              <Translate contentKey="tinyMedicRestApp.treatmentDrug.administedDoseUnit">Administed Dose Unit</Translate>
            </span>
          </dt>
          <dd>{treatmentDrugEntity.administedDoseUnit}</dd>
          <dt>
            <span id="administedDoseDilution">
              <Translate contentKey="tinyMedicRestApp.treatmentDrug.administedDoseDilution">Administed Dose Dilution</Translate>
            </span>
          </dt>
          <dd>{treatmentDrugEntity.administedDoseDilution}</dd>
          <dt>
            <span id="active">
              <Translate contentKey="tinyMedicRestApp.treatmentDrug.active">Active</Translate>
            </span>
          </dt>
          <dd>{treatmentDrugEntity.active ? 'true' : 'false'}</dd>
          <dt>
            <span id="cursor">
              <Translate contentKey="tinyMedicRestApp.treatmentDrug.cursor">Cursor</Translate>
            </span>
          </dt>
          <dd>{treatmentDrugEntity.cursor}</dd>
          <dt>
            <span id="lastUpdated">
              <Translate contentKey="tinyMedicRestApp.treatmentDrug.lastUpdated">Last Updated</Translate>
            </span>
          </dt>
          <dd>{treatmentDrugEntity.lastUpdated}</dd>
          <dt>
            <span id="microSec">
              <Translate contentKey="tinyMedicRestApp.treatmentDrug.microSec">Micro Sec</Translate>
            </span>
          </dt>
          <dd>{treatmentDrugEntity.microSec}</dd>
          <dt>
            <span id="timestampEntry">
              <Translate contentKey="tinyMedicRestApp.treatmentDrug.timestampEntry">Timestamp Entry</Translate>
            </span>
          </dt>
          <dd>{treatmentDrugEntity.timestampEntry}</dd>
          <dt>
            <span id="notes">
              <Translate contentKey="tinyMedicRestApp.treatmentDrug.notes">Notes</Translate>
            </span>
          </dt>
          <dd>{treatmentDrugEntity.notes}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.treatmentDrug.administeredDrug">Administered Drug</Translate>
          </dt>
          <dd>{treatmentDrugEntity.administeredDrug ? treatmentDrugEntity.administeredDrug.id : ''}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.treatmentDrug.administeringNurse">Administering Nurse</Translate>
          </dt>
          <dd>{treatmentDrugEntity.administeringNurse ? treatmentDrugEntity.administeringNurse.id : ''}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.treatmentDrug.validatingNurse">Validating Nurse</Translate>
          </dt>
          <dd>{treatmentDrugEntity.validatingNurse ? treatmentDrugEntity.validatingNurse.id : ''}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.treatmentDrug.cycle">Cycle</Translate>
          </dt>
          <dd>{treatmentDrugEntity.cycle ? treatmentDrugEntity.cycle.id : ''}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.treatmentDrug.regimenDrug">Regimen Drug</Translate>
          </dt>
          <dd>{treatmentDrugEntity.regimenDrug ? treatmentDrugEntity.regimenDrug.id : ''}</dd>
        </dl>
        <Button tag={Link} to="/treatment-drug" replace color="info" data-cy="entityDetailsBackButton">
          <FontAwesomeIcon icon="arrow-left" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.back">Back</Translate>
          </span>
        </Button>
        &nbsp;
        <Button tag={Link} to={`/treatment-drug/${treatmentDrugEntity.id}/edit`} replace color="primary">
          <FontAwesomeIcon icon="pencil-alt" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.edit">Edit</Translate>
          </span>
        </Button>
      </Col>
    </Row>
  );
};

export default TreatmentDrugDetail;
